import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Watchlist from "./Watchlist";
import Transaction from "./Transaction";
import Portfolio from "./Portfolio";
import Filter from "./Filter";
import Sip from "./Sip";
import SipCease from "./SipCease";
import Performance from "./Performance";
import Account from "./Account";
import SipTransaction from "./SipTransaction";

function MFRoutes() {
  return (
    <>
      <Routes>
        <Route path="watchlist" element={<Watchlist />} />
        <Route path="portfolio" element={<Portfolio />} />
        <Route path="sip" element={<Sip />} />
        <Route path="clientaccount" element={<Account />} />
        <Route path="transaction" element={<Transaction />} />
        <Route path="siptransaction" element={<SipTransaction />} />
        <Route path="sip-cease" element={<SipCease />} />
        <Route path="Performance" element={<Performance />} />
        <Route path="filter" element={<Filter />} />

        <Route path="*" element={<Navigate to="/account/mf/portfolio" />} />
      </Routes>
    </>
  );
}

export default MFRoutes;
